module.exports = __webpack_public_path__ + "img/image-id-card.60ad855a.png";